/**
 * PROFILE-PASSWORD-UX-A1 — feature-local safe error normalization.
 * Do not change shared messageFromError or global user-action error semantics.
 */

export const SEND_CODE_ERROR =
  "Не вдалося надіслати код. Спробуйте ще раз.";

export const TRANSPORT_ERROR =
  "Не вдалося з'єднатися із сервером. Перевірте інтернет і спробуйте ще раз.";

export const INVALID_CODE_ERROR =
  "Код недійсний або прострочений. Запросіть новий код і спробуйте ще раз.";

export const CONFIRM_UNKNOWN_ERROR =
  "Не вдалося змінити пароль. Спробуйте ще раз.";

export const FIELD_CODE_REQUIRED = "Введіть код підтвердження.";
export const FIELD_PASSWORD_REQUIRED = "Введіть новий пароль.";
export const FIELD_CONFIRM_REQUIRED = "Повторіть новий пароль.";
export const FIELD_PASSWORD_MISMATCH = "Паролі не збігаються.";

function looksLikeHtml(value) {
  return /<\/?[a-z][\s\S]*>/i.test(value);
}

function isTransportMessage(value) {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (trimmed === "Network Error") return true;
  if (/^network error$/i.test(trimmed)) return true;
  if (/ECONNABORTED|ETIMEDOUT|timeout/i.test(trimmed)) return true;
  return false;
}

function isInvalidCodeMessage(value) {
  if (typeof value !== "string") return false;
  return /not validated|verify the code|код не пройшов|недійсн|простроч|already used|вже використ/i.test(
    value
  );
}

/**
 * Preserve only already-safe Ukrainian human-readable validator guidance.
 * English password-related backend text must NOT reach the Ukrainian UI.
 */
function isSafeUkrainianValidatorMessage(value) {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (looksLikeHtml(trimmed)) return false;
  if (isTransportMessage(trimmed)) return false;
  if (/^\s*Error:/i.test(trimmed)) return false;
  if (/at\s+\S+\s+\(/.test(trimmed)) return false;
  if (/AxiosError|TypeError|ReferenceError|Internal Server Error/i.test(trimmed)) {
    return false;
  }
  // Require Ukrainian Cyrillic. Do not accept English merely because it
  // mentions password / too short / too common / similar / numeric.
  return /[А-Яа-яЁёІіЇїЄєҐґ]/.test(trimmed);
}

export function mapSendPasswordCodeError(error) {
  if (error == null || error === "") return SEND_CODE_ERROR;
  if (Array.isArray(error)) return SEND_CODE_ERROR;
  if (typeof error === "string") {
    if (isTransportMessage(error)) return TRANSPORT_ERROR;
    return SEND_CODE_ERROR;
  }
  return SEND_CODE_ERROR;
}

export function mapConfirmPasswordError(error) {
  if (error == null || error === "") return CONFIRM_UNKNOWN_ERROR;

  if (Array.isArray(error)) {
    const safe = error
      .filter(
        (item) =>
          typeof item === "string" && isSafeUkrainianValidatorMessage(item)
      )
      .map((item) => item.trim());
    if (safe.length > 0) return safe.join(" ");
    return CONFIRM_UNKNOWN_ERROR;
  }

  if (typeof error === "string") {
    if (isTransportMessage(error)) return TRANSPORT_ERROR;
    if (looksLikeHtml(error)) return CONFIRM_UNKNOWN_ERROR;
    if (isInvalidCodeMessage(error)) return INVALID_CODE_ERROR;
    if (isSafeUkrainianValidatorMessage(error)) return error.trim();
    return CONFIRM_UNKNOWN_ERROR;
  }

  return CONFIRM_UNKNOWN_ERROR;
}
